import { useEffect, useReducer } from 'react';

const usePersistedReducer = (reducer, initialState, init, key, storage) => {
  const [state, dispatch] = useReducer(reducer, storage.get(key, initialState), init);

  useEffect(() => {
    if(key==='state'){
      state.app.employeeStatus = {}
    }
    storage.set(key, state);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  return [state, dispatch];
};
export default usePersistedReducer;
